module.exports = __webpack_public_path__ + "assets/cyber_black.71e58110.svg";